// src/pages/common-components/Auth/ForgotPassword.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import { AuthCard, AuthError, AuthSuccess, authInputStyle, authLabelStyle, authSubmitStyle, friendlyAuthError } from './AuthShared';

const ForgotPassword: React.FC = () => {
  const { resetPassword } = useAuth();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setSubmitting(true);
    setError('');
    setSuccess('');
    try {
      await resetPassword(email.trim());
      setSuccess("If an account exists for that email, we've sent a password reset link. Please check your inbox.");
    } catch (err: any) {
      // Firebase throws auth/user-not-found for unregistered emails — avoid
      // confirming/denying account existence to keep the same generic message.
      if (err?.code === 'auth/user-not-found') {
        setSuccess("If an account exists for that email, we've sent a password reset link. Please check your inbox.");
      } else {
        setError(friendlyAuthError(err));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthCard title="Forgot Password" subtitle="Enter your email and we'll send you a reset link">
      <form onSubmit={handleSubmit}>
        <AuthError message={error} />
        <AuthSuccess message={success} />

        <div style={{ marginBottom: 22 }}>
          <label style={authLabelStyle}>Email Address</label>
          <input
            type="email"
            style={authInputStyle}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
          />
        </div>

        <button type="submit" style={{ ...authSubmitStyle, opacity: submitting ? 0.7 : 1 }} disabled={submitting}>
          {submitting ? 'Sending…' : 'Send Reset Link'}
        </button>

        <p style={{ textAlign: 'center', fontSize: 14, color: '#666', marginTop: 22, marginBottom: 0 }}>
          Remembered your password? <Link to="/login" style={{ color: '#717fe0', fontWeight: 600 }}>Sign In</Link>
        </p>
      </form>
    </AuthCard>
  );
};

export default ForgotPassword;
